import React, { useState } from 'react'
import img from '../photo_video/photo.jpg'
import axios from 'axios'
import Swal from 'sweetalert2'
import spinner from '../spnnier.gif'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import moment from 'moment'

function Contact() {
    const [data, setData] = useState({ name: '', mobile: '', age: '', other: '',city:'',goal:[] })
    const [disabled, setDisabled] = useState(false)

    const handleChange = (e,type) => {
        if(type == 'check'){
            let index = data.goal.indexOf(e.target.name)
            console.log(index)
            if(index<0){
                data.goal.push(e.target.name)
            }
            else{
                data.goal.splice(index,1)
            }
            return
        }
        setData({ ...data, [e.target.name]: e.target.value })
    }
    const handleSubmit = async (e) => {
        setDisabled(true)
        let arr=[]
        e.preventDefault()
        data.date = moment(new Date).format('LLL')

        const req = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            url: `${process.env.REACT_APP_BASE_URL}/form`,
            data: JSON.stringify(data)
        }
        await axios(req).then((response) => {
            setData({ name: '', mobile: '', age: '', other: '',city:'',goal:[] })
            Swal.fire({
                title: "Success",
                text: 'Your response has been saved',
                icon: "success",
            });
        })
            .catch((res) => {
                Swal.fire({
                    title: "Error",
                    text: `Some Error Occur`,
                    icon: "error",
                });
            })
            .finally(() => {
                setDisabled(false)

            })
    }
    return (
        <div className='container row mt-5 m-auto' id='contactus'>
                <div className='d-flex'>
                    <div className='mb-4 position-relative'><h2 className='pageHeader'>Register Now</h2></div>
                </div>
            <div className='col-md-8 mb-2  order-lg-1 order-2 '>
                <div>
                    <Form  onSubmit={(e) => { handleSubmit(e) }}>
                        <Form.Group as={Col} md="12" className='mt-2'>
                            <Form.Label>Name</Form.Label>
                            <Form.Label>&nbsp;( नाम )*</Form.Label>

                            <Form.Control
                                type="text"
                                placeholder="Name"
                                onChange={(e) => { handleChange(e,'') }}
                                value={data.name}
                                name='name'
                                required
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="12" className='mt-4'>
                            <Form.Label>Age</Form.Label>
                            <Form.Label>&nbsp;( उम्र )*</Form.Label>

                            <Form.Control
                                type="number"
                                placeholder="Age"
                                onChange={(e) => { handleChange(e,'') }} 
                                value={data.age}
                                name='age'
                                required
                            />
                        </Form.Group>
                       
                        <Form.Group as={Col} md="12" className='mt-4'>
                            <Form.Label>City</Form.Label>
                            <Form.Label>&nbsp; ( शहर )*</Form.Label>

                            <Form.Control
                                type="text"
                                placeholder="city"
                                value={data.city}
                                name='city'
                                required
                                onChange={(e) => { handleChange(e,'') }} 
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="12" className='mt-4'>
                            <Form.Label>You Health Goal</Form.Label>
                            <Form.Label>&nbsp;(आपके स्वास्थ्य लक्ष्य)</Form.Label>
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name='Healthy Weight Loose' aria-label="स्वस्थ वजन घटाना" label="Healthy Weight Loose  (स्वस्थ वजन घटाना)" />
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name="Healthy Weight Gain" aria-label="स्वस्थ वजन बढ़ना" label="Healthy Weight Gain  (स्वस्थ वजन बढ़ना)"/>
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name="Balanced Diet" aria-label="संतुलित आहार" label="Balanced Diet  (संतुलित आहार)" />
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name="Healthy Skin" aria-label="स्वस्थ त्वचा" label="Healthy Skin  (स्वस्थ त्वचा ) " />
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name="Child Heath" aria-label="बाल स्वास्थ्य" label="Child Heath  (बाल स्वास्थ्य)" />
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name="Digetion Health" aria-label="पाचन स्वास्थ्य" label="Digetion Health  (पाचन स्वास्थ्य)" />
                            <Form.Check onChange={(e) => { handleChange(e,'check') }} name="Healthy Life Style" aria-label="स्वस्थ जीवन शैली" label="Healthy Life Style (स्वस्थ जीवन शैली)" />

                        </Form.Group>
                        <Form.Group as={Col} md="12" className='mt-4'>
                            <Form.Label>Other Health Goal</Form.Label>
                            <Form.Label>&nbsp;( अन्य स्वास्थ्य लक्ष्य )</Form.Label>

                            <Form.Control
                                type="text"
                                placeholder="Other"
                                name='other'
                                value={data.other}
                                onChange={(e) => { handleChange(e,'') }} 
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="12" className='mt-4'>
                            <Form.Label>Whatsapp Number</Form.Label>
                            <Form.Label>&nbsp;( व्हाट्सएप नंबर )*</Form.Label>

                            <Form.Control
                                type="number"
                                placeholder="Number"
                                value={data.mobile}
                                name='mobile'
                                required
                                onChange={(e) => { handleChange(e,'') }} 
                            />
                        </Form.Group>

                        <button type='submit'  className={disabled ? 'disabled mt-4' : 'submitBtn mt-4'} disabled={disabled} id="mc-embedded-subscribe">
                            {disabled && <img src={spinner} alt="" style={{ height: '100%' }} />}
                            {!disabled && 'Submit'}
                        </button>
                    </Form>
                </div>
            </div>
            <div className='col-lg-4 order-lg-2 order-1 mb-5 d-lg-block' style={{display:'none'}}>
                <div className='imgContainer'>
                    <img src={img} alt="" className='contactImg' style={{ height: '100%', width: '100%' }} />
                </div>
            </div>
        </div>
    )
}

export default Contact
